export class CodeClipboardHandler {
	static init() {
		new CodeClipboardHandler();
	}
	constructor() {
		const elements = Array.from(document.querySelectorAll('[data-widget=copycode]')) as HTMLElement[];
		for (let element of elements) {
			this._initElement(element);
		}
	}
	private _initElement(element: HTMLElement) {
		element.addEventListener('click', () => {
			this._onElementClick(element);
		});
	}
	private _onElementClick(element: HTMLElement) {
		const targetId = element.dataset['target'];
		if (!targetId) {
			console.error(`this element has no target ${targetId}`);
			return;
		}
		const targetElement = document.getElementById(targetId);
		if (!targetElement) {
			console.error('target not found');
			return;
		}
		const content = targetElement.innerText;
		const inputElement = document.createElement('textarea');
		inputElement.value = content;

		inputElement.select();
		inputElement.setSelectionRange(0, 99999); /* For mobile devices */

		/* Copy the text inside the text field */
		navigator.clipboard.writeText(inputElement.value);
	}
}
